<mat-card class="nested-card" [style.border-left-color]="getDepthColor()" [class.level-selected]="isThisLevelSelected()">
  <!-- Level Header -->
  <mat-card-header class="level-header" (click)="onSelectLevel()">
    <div class="header-content">
      <button mat-icon-button class="expand-btn" (click)="toggleExpanded(); $event.stopPropagation()">
        <mat-icon>{{ level.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      
      <mat-icon class="level-icon" [style.color]="getDepthColor()">folder_open</mat-icon>

      <span class="level-name-display">{{ level.name || ('FORM_BUILDER.LEVEL_NAME' | translate) }}</span>
      
      <mat-form-field appearance="outline" class="level-name-field" (click)="$event.stopPropagation()">
        <input matInput [(ngModel)]="level.name" [placeholder]="'FORM_BUILDER.LEVEL_NAME' | translate">
      </mat-form-field>
      
      <div class="level-info">
        <mat-chip class="depth-chip" [style.background-color]="getDepthColor()">
          {{ 'FORM_BUILDER.LEVEL' | translate }} {{ depth + 1 }}
        </mat-chip>
        <span class="field-count">{{ level.fields.length }} {{ 'FORM_BUILDER.FIELDS' | translate }}</span>
      </div>
    </div>
    
    <div class="level-actions">
      <button mat-icon-button (click)="onSelectLevel(); $event.stopPropagation()" matTooltip="{{ 'ACTION.EDIT' | translate }}">
        <mat-icon>settings</mat-icon>
      </button>
      <button mat-icon-button (click)="onDuplicateLevel(); $event.stopPropagation()" matTooltip="{{ 'FORM_BUILDER.DUPLICATE_LEVEL' | translate }}">
        <mat-icon>content_copy</mat-icon>
      </button>
      <button mat-icon-button color="warn" (click)="onRemoveLevel(); $event.stopPropagation()" matTooltip="{{ 'FORM_BUILDER.REMOVE_LEVEL' | translate }}">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </mat-card-header>

  <!-- Level Content (collapsible) -->
  <mat-card-content *ngIf="level.isExpanded" class="level-content">
    <!-- Native HTML5 Drop Zone for palette items -->
    <div
      class="drop-zone"
      cdkDropList
      [id]="'level-' + level.id"
      [cdkDropListData]="level.fields"
      [cdkDropListConnectedTo]="connectedDropLists"
      (cdkDropListDropped)="onDrop($event)"
      [class.empty]="level.fields.length === 0"
      [class.drag-over]="isDragOver"
      (dragover)="onNativeDragOver($event)"
      (dragleave)="onNativeDragLeave($event)"
      (drop)="onNativeDrop($event)">
      
      <!-- Empty State -->
      <div *ngIf="level.fields.length === 0" class="empty-state">
        <mat-icon>add_circle_outline</mat-icon>
        <p>{{ 'FORM_BUILDER.DROP_FIELDS_HERE' | translate }}</p>
      </div>

      <!-- Field Items - Draggable with CDK -->
      <div
        *ngFor="let field of level.fields; let i = index; trackBy: trackByFieldId"
        class="field-item"
        cdkDrag
        [cdkDragData]="field"
        [class.selected]="isFieldSelected(field)"
        (click)="selectField(field)">
        
        <div class="drag-handle" cdkDragHandle>
          <mat-icon>drag_indicator</mat-icon>
        </div>

        <div class="field-preview">
          <mat-icon class="field-type-icon">{{ getFieldTypeIcon(field.type) }}</mat-icon>
          <div class="field-info">
            <span class="field-label">{{ field.label || ('FORM_BUILDER.UNNAMED_FIELD' | translate) }}</span>
            <span class="field-type">{{ 'FORM_BUILDER.FIELD_TYPES.' + field.type.toUpperCase() | translate }}</span>
          </div>
          <mat-chip *ngIf="field.required" class="required-chip">
            {{ 'FORM_BUILDER.REQUIRED' | translate }}
          </mat-chip>
          <mat-icon *ngIf="field.allowPhoto" class="photo-indicator" matTooltip="{{ 'FORM_BUILDER.CONFIG.ALLOW_PHOTO' | translate }}">photo_camera</mat-icon>
        </div>

        <div class="field-actions">
          <button mat-icon-button (click)="selectField(field); $event.stopPropagation()">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="removeField(field, $event)">
            <mat-icon class="delete-icon">delete</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Add Nested Level Button -->
    <button
      *ngIf="canAddNestedLevel()"
      mat-raised-button
      color="accent"
      class="add-level-btn"
      (click)="onAddNestedLevel()">
      <mat-icon class="mr-1">add</mat-icon>
      {{ 'FORM_BUILDER.ADD_NESTED_LEVEL' | translate }}
    </button>

    <!-- Child Nested Levels -->
    <ng-container *ngFor="let childLevel of level.children">
      <lib-nested-level
        [level]="childLevel"
        [parent]="level"
        [depth]="depth + 1"
        [selectedField]="selectedField"
        [selectedLevelForConfig]="selectedLevelForConfig"
        [connectedDropLists]="connectedDropLists"
        (fieldAdded)="onChildFieldAdded($event)"
        (fieldRemoved)="onChildFieldRemoved($event)"
        (fieldsReordered)="onChildFieldsReordered($event)"
        (fieldSelected)="onChildFieldSelected($event)"
        (levelSelected)="onChildLevelSelected($event)"
        (addNestedLevel)="onChildAddNestedLevel($event)"
        (removeLevel)="onChildRemoveLevel($event)"
        (duplicateLevel)="onChildDuplicateLevel($event)">
      </lib-nested-level>
    </ng-container>
  </mat-card-content>
</mat-card>
